import { z } from "zod";
import { BaseEventSchema } from "./pubsub.schema";

// =========================================================================
// SHOPIFY APP_SUBSCRIPTIONS_UPDATE WEBHOOK PAYLOAD
// =========================================================================

export const AppSubscriptionWebhookPayloadSchema = z.object({
  admin_graphql_api_id: z.string(), // "gid://shopify/AppSubscription/..."
  name: z.string(),
  status: z.enum([
    "ACTIVE",
    "CANCELLED",
    "DECLINED",
    "EXPIRED",
    "FROZEN",
    "PENDING",
  ]),
  admin_graphql_api_shop_id: z.string().optional(),
  created_at: z.string(),
  updated_at: z.string(),
  currency: z.string(),
  plan_handle: z.string().optional(),
  price: z.string().nullable().optional(),
  interval: z.string().optional(),
  capped_amount: z.string().nullable().optional(),
  trial_days: z.number().optional(),
  billing_on: z.string().nullable().optional(),
  test: z.boolean().optional(),
  activated_on: z.string().nullable().optional(),
  cancelled_on: z.string().nullable().optional(),
  trial_ends_on: z.string().nullable().optional(),
  current_period_end: z.string().nullable().optional(),
});

export type AppSubscriptionWebhookPayload = z.infer<
  typeof AppSubscriptionWebhookPayloadSchema
>;

// =========================================================================
// BILLING WEBHOOK EVENT (Pub/Sub)
// =========================================================================

export const BillingWebhookEventSchema = BaseEventSchema.extend({
  event_type: z.literal("billing.subscription_updated"),
  shop_domain: z.string(),
  payload: AppSubscriptionWebhookPayloadSchema,
});

export type BillingWebhookEvent = z.infer<typeof BillingWebhookEventSchema>;
